// extracted by mini-css-extract-plugin
module.exports = {"container":"_3Cw8UNF5FJh2mnYXW7teUy","icon":"_2pViIe7mxm3Xm7wCTuGydP"};